function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import { bool, func, instanceOf, string, shape, PropTypes, oneOfType } from 'prop-types'; // components

import Button from '../button'; // styles

import { Heighten, UList, TimeList } from './styled/styles'; // utils

import { DateFormatHandler } from '../utils/dateFormat';

var TimesList = function TimesList(_ref) {
  var _times$date, _times$date2;

  var btnActive = _ref.btnActive,
      bgColorSelected = _ref.bgColorSelected,
      className = _ref.className,
      dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsLabel = _ref.dataAnalyticsLabel,
      theme = _ref.theme,
      times = _ref.times,
      _onClick = _ref.onClick,
      expand = _ref.expand,
      viewType = _ref.viewType;

  // set default columns to display based on viewType 'base' (3) vs 'daily' (12) vs 'weekly' (4/day)
  var _useState = useState(3),
      _useState2 = _slicedToArray(_useState, 2),
      numberOfSlots = _useState2[0],
      setNumberOfSlots = _useState2[1];

  var _useState3 = useState(30),
      _useState4 = _slicedToArray(_useState3, 2),
      maxSlotsDisplay = _useState4[0],
      setMaxSlotsDisplay = _useState4[1];

  var _useState5 = useState(times),
      _useState6 = _slicedToArray(_useState5, 2),
      timeList = _useState6[0],
      setTimeList = _useState6[1];

  useEffect(function () {
    if (viewType === 'daily') {
      setTimeList((times === null || times === void 0 ? void 0 : times.data) || times);
      setNumberOfSlots(12);
    } else if (viewType === 'weekly') {
      setTimeList(times === null || times === void 0 ? void 0 : times.slots);
      setNumberOfSlots(4);
      setMaxSlotsDisplay(40);
    } else {
      setTimeList((times === null || times === void 0 ? void 0 : times.data) || times);
    }
  });
  return times && /*#__PURE__*/React.createElement(UList, {
    viewType: viewType
  }, viewType === 'weekly' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    style: {
      lineHeight: '26px',
      fontWeight: '600'
    }
  }, (_times$date = times.date) === null || _times$date === void 0 ? void 0 : _times$date.split(', ')[0]), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '0 0 20px',
      padding: 0,
      paddingTop: 0,
      fontWeight: '500'
    }
  }, (_times$date2 = times.date) === null || _times$date2 === void 0 ? void 0 : _times$date2.split(', ')[1])), timeList !== null && timeList !== void 0 && timeList.length ? timeList.map(function (time) {
    return /*#__PURE__*/React.createElement(TimeList, {
      key: time.id || (time === null || time === void 0 ? void 0 : time.datetime) || time,
      viewType: viewType,
      bgColorSelected: bgColorSelected,
      className: "scl-timeSlot-list ".concat(className),
      "data-test-id": "scl-timeSlot-list"
    }, /*#__PURE__*/React.createElement(Button, {
      alignment: "align-center",
      theme: theme,
      bgColorHover: "#fff",
      borderHover: "#fff",
      className: "scl-timeslot-btn  ".concat((time === null || time === void 0 ? void 0 : time.datetime) === btnActive || time === btnActive ? 'selected' : ''),
      dataAnalyticsLabel: dataAnalyticsLabel,
      dataAnalyticsId: "scl-timeslot_btn ".concat(dataAnalyticsId),
      "data-test-id": "scl-timeslot-btn ".concat((time === null || time === void 0 ? void 0 : time.datetime) || time),
      expand: true,
      value: (time === null || time === void 0 ? void 0 : time.datetime) || time,
      onClick: function onClick() {
        return _onClick(time);
      },
      variant: "primary"
    }, DateFormatHandler((time === null || time === void 0 ? void 0 : time.datetime) || time, 'time')));
  }).splice(0, expand ? numberOfSlots : maxSlotsDisplay) : /*#__PURE__*/React.createElement(Heighten, null, /*#__PURE__*/React.createElement("hr", null)));
};

TimesList.propTypes = {
  btnActive: oneOfType([string, shape({})]),

  /**
  Optional: color for background of selected time slot
  */
  bgColorSelected: string,

  /**
  /**
  Optional: className for each individual time slot rendering
  */
  className: string,

  /**
   * Define data analytics label
   */
  dataAnalyticsLabel: string,

  /**
   * Define data analytics id
   */
  dataAnalyticsId: string,

  /**
  color theme for button
  */
  theme: string,

  /**
  Select handler to pass back value of selected item
  */
  onClick: func,

  /**
  Number of time slots to display based on toggle see more state
  */
  expand: bool,

  /**
  Takes in an Array of times or objects (weekly) and outputs in time slots
  */
  times: PropTypes.oneOfType([PropTypes.object, instanceOf(Array)]),

  /**
  State whether the view type is 'base', 'daily' or 'weekly'
  */
  viewType: string
};
export default TimesList;